export default "__VITE_ASSET__CH3eZ6fi__"